import type { CSSProperties, FC } from 'react';
import type { SequenceLayout } from './layout-sequence';
import { HEADER_HEIGHT } from './sequence-constants';
import { SequenceArrowMarkers } from './SequenceArrowMarkers';
import { SequenceBlockFrame } from './SequenceBlockFrame';
import { SequenceMessage } from './SequenceMessage';
import { SequenceNote } from './SequenceNote';
import { SequenceParticipant } from './SequenceParticipant';
import { SequenceTitle } from './SequenceTitle';
const SEQUENCE_SVG_XMLNS = 'http://www.w3.org/2000/svg';
const SEQUENCE_SVG_MAX_WIDTH = '100%';
const SEQUENCE_SVG_HEIGHT_AUTO = 'auto';
const SEQUENCE_SVG_DISPLAY_BLOCK = 'block';
const SEQUENCE_SVG_MARGIN_AUTO = '0 auto';
const sequenceSvgStyle: CSSProperties = {
    maxWidth: SEQUENCE_SVG_MAX_WIDTH,
    height: SEQUENCE_SVG_HEIGHT_AUTO,
    display: SEQUENCE_SVG_DISPLAY_BLOCK,
    margin: SEQUENCE_SVG_MARGIN_AUTO,
};
interface SequenceDiagramSvgProps {
    layout: SequenceLayout;
}
export const SequenceDiagramSvg: FC<SequenceDiagramSvgProps> = ({ layout }) => {
    const headerTop = layout.lifelineTop - HEADER_HEIGHT;
    return (
    <svg width={layout.width} height={layout.height} viewBox={`0 0 ${layout.width} ${layout.height}`} xmlns={SEQUENCE_SVG_XMLNS} style={sequenceSvgStyle}>
      <SequenceArrowMarkers />
      <SequenceTitle layout={layout}/>

      {layout.blocks.map((block) => (<SequenceBlockFrame key={`block-${block.blockType}-${block.label}-${block.y}`} block={block}/>))}

      {layout.lanes.map((lane) => (<SequenceParticipant key={lane.id} lane={lane} headerTop={headerTop} lifelineTop={layout.lifelineTop} lifelineBottom={layout.lifelineBottom}/>))}

      {layout.notes.map((note) => (<SequenceNote key={`note-${note.text}-${note.y}`} note={note}/>))}

      {layout.messages.map((message) => (<SequenceMessage key={`msg-${message.fromId}-${message.toId}-${message.arrow}-${message.text}-${message.y}`} message={message}/>))}
    </svg>
    );
};
